import { airColumns } from './columns/air-data'
import { blockingColumns } from './columns/blocking-data'
import { heatColumns } from './columns/heat-data'
import { inverterColumns } from './columns/inverter-data'
import { lowColumns } from './columns/low-data'
import { overloadColumns } from './columns/overload-data'
import { overflowingColumns } from './columns/overflowing-data'
import { oneyearoutColumns } from './columns/oneyearout-data'
import maintainColumns from './columns/maintain'
import lowApplyPressureColumns from './columns/lowApplyPressure'
import estAirFilterBlockedColumns from './columns/estAirFilterBlocked'
import estOilSeparatorBlockedColumns from './columns/estOilSeparatorBlocked'
import estHighTemperatureColumns from './columns/estHighTemperature'
import estAirInletTemperatureColumns from './columns/estAirInletTemperature'
import estInverterHighTemperatureColumns from './columns/estInverterHighTemperature'
import estFanBoxOverloadColumns from './columns/estFanBoxOverload'
import estCoolingWaterBreakColumns from './columns/estCoolingWaterBreak'
import estElectronicFanOverloadColumns from './columns/estElectronicFanOverload'
import estLowOilInletPressureColumns from './columns/estLowOilInletPressure'
import estMotorBreaingHighTemperatureColumns from './columns/estMotorBreaingHighTemperature'
import estMotorWindingHighTemperatureColumns from './columns/estMotorWindingHighTemperature'
import startFrequentlyColumns from "./columns/startFrequently"
import loadFrequentlyColumns from "./columns/loadFrequently"
import overPressureColumns from './columns/overPressure'
import motorHtColumns from './columns/motorHt.JS'
import outElectricTrendColumns from "./columns/outElectricTrend"

export default [
  {
    type: 'MAINTAIN',
    zh: '维保预警',
    en: 'Maintain',
    columns: maintainColumns,
    sort: 0
  },
  {
    type: 'AIR_INSUFFICIENCY',
    zh: '气量不足',
    en: 'Air Insufficiency',
    columns: airColumns,
    sort: 1
  },
  {
    type: 'AIR_FILTER_BLOCKED',
    zh: '空滤堵塞',
    en: 'Air Filter Blocked',
    columns: blockingColumns,
    sort: 2
  },
  {
    type: 'HIGH_TEMPERATURE',
    zh: '高温预警',
    en: 'High Temperature',
    columns: heatColumns,
    sort: 3
  },
  {
    type: 'INVERTER_HIGH_TEMPERATURE',
    zh: '变频器高温',
    en: 'Inverter High Temperature',
    columns: inverterColumns,
    sort: 4
  },
  {
    type: 'LOW_FREQUENCY',
    zh: '低温预警',
    en: 'Low Frequency',
    columns: lowColumns,
    sort: 5
  },
  {
    type: 'OVERLOAD',
    zh: '空压机过载',
    en: 'Overload',
    columns: overloadColumns,
    sort: 6
  },
  {
    type: 'OVER_CURRENT',
    zh: '过流预警',
    en: 'Over Current',
    columns: overflowingColumns,
    sort: 7
  },
  {
    type: 'LOW_APPLY_PRESSURE',
    zh: '应用压力低',
    en: 'Low Apply Pressure',
    columns: lowApplyPressureColumns,
    sort: 8
  },
  {
    type: 'EST_AIR_FILTER_BLOCKED',
    zh: '空滤堵塞',
    en: 'Est Air Filter Blocked',
    columns: estAirFilterBlockedColumns,
    sort: 9
  },
  {
    type: 'EST_COOLING_WATER_BREAK',
    zh: '冷却水断开',
    en: 'Est Cooling Water Break',
    columns: estCoolingWaterBreakColumns,
    sort: 10
  },
  {
    type: 'EST_ELECTRONIC_FAN_OVERLOAD',
    zh: '电控风机过载',
    en: 'Est Electronic Fan Overload',
    columns: estElectronicFanOverloadColumns,
    sort: 11
  },
  {
    type: 'EST_FAN_BOX_OVERLOAD',
    zh: '箱体风机过载',
    en: 'Est Fan Box Overload',
    columns: estFanBoxOverloadColumns,
    sort: 12
  },
  {
    type: 'EST_HIGH_TEMPERATURE',
    zh: '高温预警',
    en: 'Est High Temperature',
    columns: estHighTemperatureColumns,
    sort: 13
  },
  {
    type: 'EST_INVERTER_HIGH_TEMPERATURE',
    zh: '变频高温',
    en: 'Est Inverter High Temperature',
    columns: estInverterHighTemperatureColumns,
    sort: 14
  },
  {
    type: 'EST_LOW_OIL_INLET_PRESSURE',
    zh: '进油压力低',
    en: 'Est Low Oli Inlet Pressure',
    columns: estLowOilInletPressureColumns,
    sort: 15
  },
  {
    type: 'EST_MOTOR_BEARING_HIGH_TEMPERATURE',
    zh: '电机轴承高温',
    en: 'Est Motor Bearing High Temperature',
    columns: estMotorBreaingHighTemperatureColumns,
    sort: 16
  },
  {
    type: 'EST_MOTOR_WINDING_HIGH_TEMPERATURE',
    zh: '电机绕组高温',
    en: 'Est Motor Winding High Temperature',
    columns: estMotorWindingHighTemperatureColumns,
    sort: 17
  },
  {
    type: 'EST_OIL_SEPARATOR_BLOCKED',
    zh: '油分堵塞',
    en: 'Est Oil Separator Blocked',
    columns: estOilSeparatorBlockedColumns,
    sort: 18
  },
  {
    type: 'EST_AIR_INLET_TEMPERATURE',
    zh: '进气高温',
    en: 'Est Air Inlet Temperature',
    columns: estAirInletTemperatureColumns,
    sort: 19
  },
  {
    type: 'ONE_YEAR_WITHOUT_MAINTAIN',
    zh: '一年未保养',
    en: 'One Year without maintain',
    columns: oneyearoutColumns,
    sort: 20
  },
  {
    type: "START_FREQUENTLY",
    zh: "频繁启停",
    en: "Start Frequently",
    columns: startFrequentlyColumns,
    sort: 21
  },
  {
    type: "LOAD_FREQUENTLY",
    zh: "频繁加卸载",
    en: "Load Frequently",
    columns: loadFrequentlyColumns,
    sort: 22
  },
  {
    type: "OVER_PRESSURE",
    zh: "超压运行",
    en: "Over Pressure",
    columns: overPressureColumns,
    sort: 23
  },
  {
    type: "MOTOR_HT",
    zh: "电机温升高",
    en: "Motor heat",
    columns: motorHtColumns,
    sort: 24
  },
  {
    type: "OUT_ELECTRIC_TREND",
    zh: "电流趋势预警",
    en: "Out Electric Trend",
    columns: outElectricTrendColumns,
    sort: 25
  }
  // {
  //   type: 'INSPECTION',
  //   name: '巡检预警',
  //   columns: inspection,
  //   sort: 9
  // },
  // {
  //   type: 'ERROR',
  //   name: '故障预警',
  //   columns: error,
  //   sort: 10
  // }
]
// export default {
//   air: {
//     name: '气量不足',
//     columns: airColumns
//   },
//   blocking: {
//     name: '空滤堵塞',
//     columns: blockingColumns
//   },
//   heat: {
//     name: '高温预警',
//     columns: heatColumns
//   },
//   inverter: {
//     name: '变频器高温',
//     columns: inverterColumns
//   },
//   low: {
//     name: '低温预警',
//     columns: lowColumns
//   },
//   overload: {
//     name: '空压机过载',
//     columns: overloadColumns
//   },
//   overflowing: {
//     name: '过流预警',
//     columns: overflowingColumns
//   }
// }